//dependencies
import 'dotenv/config';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';


//components
import App from './App';
import ScrollToTop from './components/ScrollToTop';
import * as serviceWorker from './services/serviceWorker';

//css
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';



ReactDOM.render(
  <Router>
    <ScrollToTop>
      <App />
    </ScrollToTop>
  </Router>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
